import { MainTitle } from 'components/MainTitle';
import { Layout } from 'features/Layouts/Layouts';
import { FC, useEffect, useRef, useState } from 'react';
import { EmployedsList } from 'components/EmployedsList';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { PushInvite } from 'components/PushInvite';
import { ReactComponent as IconPlus } from './img/iconPlus.svg';
import { ReactComponent as IconDownload } from './img/iconDownload2.svg';
import download from './img/iconDownload2.svg';
import { ReactComponent as IconChevronLeft } from './img/iconChewronLeft.svg';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import {
  getAuthorizationHeader,
  useGetEmployedsQuery,
  useGetFiltersEmployedsQuery,
  useGetTabEmployedsCustomerQuery,
} from 'redux/Api/employedsApi/employedsApi';
import { Button } from 'ui/Button';
import { InputSearch } from 'ui/InputSearch';
import styles from './EmployedsContent.module.scss';
import ContentLoader from 'react-content-loader';
import { Affix, Box, Group, Loader, TextInput } from '@mantine/core';
import { ReactComponent as IconClose } from './img/iconClose.svg';
import { ReactComponent as IconSearchBtn } from './img/iconSearchBtn.svg';
import { useMediaQuery, useToggle } from '@mantine/hooks';
import { EmployedsListMobile } from 'components/EmployedsListMobile';
import { Helmet } from 'react-helmet';
import { SelectMenuFilter } from 'components/SelectMenuFilter';
import { useCanManage } from 'hooks/useCanManage';
import { ItemTypes, KeysFiltersType } from 'redux/Api/employedsApi/type';
import { EmployedsTabletList } from 'components/EmployedsTabletList';
import { CategoryItem, Filters } from './Filters/Filters';
import { SortFilter } from './Sort/SortFilter';
import { MobileMenu } from './Sort/SortFilterMobile';
import ScrollButton from 'components/ScrollButton';
import { TitleRow } from 'components/TitleRow';
import { CreateEmployedsСategory } from '../../components/CreateEmployedsСategory';
import useYandexMetrica from 'hooks/useYandexMetrica';
import { useDispatch } from 'react-redux';
import { setEmployeds } from 'redux/employeds/slice';
import { SuccessErrorInfo } from 'components/SuccessErrorInfo';
import { AppTooltip } from 'ui/AppTooltip';

export const EmployedsContent: FC = () => {
  const canManage = useCanManage();
  const searchRef = useRef<HTMLInputElement>(null);
  const [isSearchOpen, toggleSearchOpen] = useToggle();
  const [mobileSearchClicked, setMobileSearchClicked] = useState(false);
  const { data: dataFilters } = useGetFiltersEmployedsQuery();
  const [textError, setTextError] = useState<string | null>(null);
  const [isCreatedModalOpen, setIsCreatedModalOpen] = useState(false);
  const dispatch = useDispatch();

  const newDataFiltersMobile = dataFilters
    ? transformFilters(dataFilters.filters)
    : { genders: [], issues: [], nationalities: [], contracts: [], categories: [] };

  const isMobile = useMediaQuery(`(width < 768px)`);
  const isMediumScreen = useMediaQuery('(width >= 768px)');
  const buttonTransform = useMediaQuery(`(min-width: 1200px)`);
  const isLessThan1595px = useMediaQuery('(width < 1595px)');
  const isLessThan1400px = useMediaQuery('(width < 1400px)');
  const [openNav, setOpenNav] = useState<boolean | undefined>(false);
  const role = localStorage.getItem('role') || 'WorkSupport';
  const [searchValue, setSearchValue] = useState('');
  const [isDownloading, setIsDownloading] = useState(false);
  const [active, setActive] = useState(localStorage.getItem('employedsFilter') || '');
  const { sendGoal } = useYandexMetrica();

  const [showCopiedSuccess, setShowCopiedSuccess] = useState(false);

  const handleCloseCopiedSuccess = () => {
    setShowCopiedSuccess(false);
  };

  const [activeSort, setActiveSort] = useState(
    localStorage.getItem('employedsSort') || 'default',
  );

  const loadFiltersFromStorage = (): {
    genders: string[];
    issues: string[];
    nationalities: string[];
    categories: CategoryItem[];
    contracts: string[];
    limit_from?: number;
    limit_to?: number;
    date_add?: { start: string; end: string };
  } => {
    try {
      const saved = localStorage.getItem('employedsFilters');
      if (saved) {
        return JSON.parse(saved);
      }
    } catch {
      // ignore parse errors
    }
    return {
      genders: [],
      issues: [],
      nationalities: [],
      categories: [],
      contracts: [],
      limit_from: undefined,
      limit_to: undefined,
      date_add: undefined,
    };
  };

  const savedFilters = loadFiltersFromStorage();

  const {
    data: dataTabs,
    isLoading: isLoadingTabs,
    refetch,
  } = useGetTabEmployedsCustomerQuery();

  const [params, setParams] = useState({
    page: 1,
    filter:
      active === 'ready'
        ? 'ready'
        : active === 'not_ready'
        ? 'not_ready'
        : active === 'blocked'
        ? 'blocked'
        : '',
    searchValue: '',
    sort:
      activeSort === 'active'
        ? 'active'
        : activeSort === 'inactive'
        ? 'inactive'
        : activeSort === 'last_name_asc'
        ? 'last_name_asc'
        : activeSort === 'last_name_desc'
        ? 'last_name_desc'
        : activeSort === 'created_at_desc'
        ? 'created_at_desc'
        : activeSort === 'created_at_asc'
        ? 'created_at_asc'
        : undefined,
    genders: savedFilters.genders ?? [],
    issues: savedFilters.issues ?? [],
    nationalities: savedFilters.nationalities ?? [],
    categories: savedFilters.categories ?? [],
    contracts: savedFilters.contracts ?? [],
    limit_from: savedFilters.limit_from,
    limit_to: savedFilters.limit_to,
    date_add: savedFilters.date_add,
  });

  const dataTitle = [
    'Исполнитель',
    'Телефон',
    'Категории исполнителей',
    'Гражданство',
    'Добавлен',
    'Лимит, ₽',
    'Проблема',
  ];

  const saveFiltersToStorage = (filters: {
    genders?: string[];
    issues?: string[];
    nationalities?: string[];
    categories?: CategoryItem[]; // ← изменено
    contracts?: string[];
    limit_from?: number;
    limit_to?: number;
    date_add?: { start: string; end: string };
  }) => {
    const toSave = {
      genders: filters.genders ?? [],
      issues: filters.issues ?? [],
      nationalities: filters.nationalities ?? [],
      categories: filters.categories ?? [],
      contracts: filters.contracts ?? [],
      limit_from: filters.limit_from,
      limit_to: filters.limit_to,
      date_add: filters.date_add,
    };
    localStorage.setItem('employedsFilters', JSON.stringify(toSave));
  };

  const apiParams = {
    ...params,
    categories: params.categories?.map((c) => c.id) ?? [],
  };

  const { data, isLoading, isFetching } = useGetEmployedsQuery(apiParams);

  useEffect(() => {
    if (data?.data) {
      dispatch(setEmployeds(data.data));
    }
  }, [data?.data, dispatch]);

  const hasNextPage = data?.meta
    ? data?.meta?.last_page !== data?.meta?.current_page
    : false;

  const showFullPageSkeleton = isLoading || (isFetching && params.page === 1);

  const [intersectionRef] = useInfiniteScroll({
    loading: isLoading,
    hasNextPage,
    onLoadMore: () => setParams((prev) => ({ ...prev, page: prev.page + 1 })),
    rootMargin: '0px 0px 160px 0px',
  });

  const [showPushInvite, setShowPushInvite] = useState(false);

  const openModal = () => {
    setShowPushInvite(true);
  };

  const handleDownload = async () => {
    sendGoal('DownloadExecutorRegistry');
    setIsDownloading(true);
    try {
      const responseFile = await fetch(
        `${process.env.REACT_APP_API_URL}/api/workers/export-to-excel`,
        {
          method: 'GET',
          headers: {
            Authorization: getAuthorizationHeader(),
          },
        },
      );

      const { file_id } = await responseFile.json();

      const responseToken = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/docs/download/one-time-token`,
        {
          method: 'GET',
          headers: {
            Authorization: getAuthorizationHeader(),
          },
        },
      );

      const { token } = await responseToken.json();

      const url = `${process.env.REACT_APP_API_URL}/api/customer/docs/workers_xlsx/${file_id}/download/${token}`;
      window.open(url, '_self');
    } catch (error) {
      setTextError('Произошла ошибка при скачивании отчета');
      throw error;
    } finally {
      setIsDownloading(false);
    }
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      setParams((prev) => ({
        ...prev,
        page: 1,
        searchValue,
      }));
    }
  };

  const mobileTabs =
    dataTabs?.items?.map((tab: ItemTypes) => ({
      value: tab.key,
      label: tab.name,
    })) || [];

  const mobileSortTabs =
    dataFilters?.sort?.map((tab: { keyword: string; title: string }) => ({
      value: tab.keyword,
      label: tab.title,
    })) || [];

  const activeTabName =
    mobileTabs.find((tab: { value: string; label: string }) => tab.value === active)
      ?.label || 'active';

  const activeSortName =
    mobileSortTabs.find(
      (tab: { value: string; label: string }) => tab.value === activeSort,
    )?.value || 'default';

  const handleTabClick = (val: string) => {
    localStorage.setItem('employedsFilter', val);
    setParams((prev) => ({
      ...prev,
      page: 1,
      filter:
        val === 'ready'
          ? 'ready'
          : val === 'not_ready'
          ? 'not_ready'
          : val === 'blocked'
          ? 'blocked'
          : '',
    }));
    setActive(val);
  };

  const handleTabClickSort = (val: string) => {
    localStorage.setItem('employedsSort', val);
    setActiveSort(val);
    setParams((prev) => ({
      ...prev,
      page: 1,
      sort:
        val === 'default'
          ? undefined
          : val === 'active'
          ? 'active'
          : val === 'inactive'
          ? 'inactive'
          : val === 'last_name_asc'
          ? 'last_name_asc'
          : val === 'last_name_desc'
          ? 'last_name_desc'
          : val === 'created_at_desc'
          ? 'created_at_desc'
          : val === 'created_at_asc'
          ? 'created_at_asc'
          : undefined,
    }));
  };

  const isShowLoading = isFetching && params.page === 1;

  const handleApplyEmployedsFilters = (filters: {
    genders?: string[];
    issues?: string[];
    nationalities?: string[];
    categories?: CategoryItem[];
    contracts?: string[];
    limit_from?: number;
    limit_to?: number;
    date_add?: { start: string; end: string };
  }) => {
    const nextFilters = {
      genders: filters.genders ?? [],
      issues: filters.issues ?? [],
      nationalities: filters.nationalities ?? [],
      categories: filters.categories ?? [],
      contracts: filters.contracts ?? [],
      limit_from: filters.limit_from,
      limit_to: filters.limit_to,
      date_add: filters.date_add,
    };
    setParams((prev) => ({
      ...prev,
      page: 1,
      ...nextFilters,
    }));
    saveFiltersToStorage(nextFilters);
  };

  const handleResetEmployedsFilters = () => {
    const emptyFilters = {
      genders: [] as string[],
      issues: [] as string[],
      nationalities: [] as string[],
      categories: [] as CategoryItem[],
      contracts: [] as string[],
      limit_from: undefined as number | undefined,
      limit_to: undefined as number | undefined,
      date_add: undefined as { start: string; end: string } | undefined,
    };
    setParams((prev) => ({
      ...prev,
      page: 1,
      ...emptyFilters,
    }));
    saveFiltersToStorage(emptyFilters);
  };

  const handleMobileSearch = () => {
    if (searchValue === '') {
      setParams((prev) => ({
        ...prev,
        page: 1,
        searchValue: '',
      }));
    } else {
      setParams((prev) => ({
        ...prev,
        searchValue,
      }));
    }
    setMobileSearchClicked(true);
  };

  const handleMobileSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    setMobileSearchClicked(false);

    if (e.target.value === '') {
      setParams((prev) => ({
        ...prev,
        page: 1,
        searchValue: '',
      }));
    }
  };

  return (
    <Layout setOpenNav={setOpenNav}>
      <Helmet>
        <title>Исполнители</title>
      </Helmet>

      {isMobile ? (
        <Box className={styles.root}>
          <div className={styles.stickyHeader} style={{ padding: 0 }}>
            {isSearchOpen ? (
              <TextInput
                flex={1}
                mb='10px'
                placeholder='Поиск'
                type='search'
                autoFocus
                ref={searchRef}
                radius='8px'
                value={searchValue}
                styles={{ input: { height: '48px', border: 'none' } }}
                leftSection={
                  <IconChevronLeft
                    style={{ width: '25px', height: '25px' }}
                    onClick={() => {
                      if (isFetching) return;
                      setSearchValue('');
                      setMobileSearchClicked(false);
                      setParams((prev) => ({
                        ...prev,
                        searchValue: '',
                      }));
                      toggleSearchOpen();
                    }}
                  />
                }
                rightSection={
                  <Group gap='8px' mr='6'>
                    {searchValue !== '' && (
                      <IconClose
                        style={{ width: '16px', height: '16px' }}
                        onClick={() => {
                          if (isFetching) return;
                          setSearchValue('');
                          setMobileSearchClicked(false);
                          setParams((prev) => ({
                            ...prev,
                            searchValue: '',
                          }));
                          searchRef?.current?.focus();
                        }}
                      />
                    )}
                    {!mobileSearchClicked && (
                      <Box
                        style={{
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                        onClick={handleMobileSearch}>
                        <IconSearchBtn style={{ width: '71px', height: '40px' }} />
                      </Box>
                    )}
                  </Group>
                }
                rightSectionWidth={
                  searchValue !== '' && !mobileSearchClicked
                    ? 110
                    : mobileSearchClicked
                    ? 50
                    : 86
                }
                onChange={handleMobileSearchChange}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    setParams((prev) => ({
                      ...prev,
                      page: 1,
                      searchValue,
                    }));
                    setMobileSearchClicked(true);
                  }
                }}
              />
            ) : (
              <MainTitle title='Избранные исполнители' count={data?.meta?.total || 0} />
            )}

            {isSearchOpen ? null : isLoadingTabs || isShowLoading ? (
              <ContentLoader
                speed={2}
                height={34}
                backgroundColor={'#FFFFFF'}
                foregroundColor={'#D8E4FB8C'}
                style={{ borderRadius: '8px', marginBottom: '12px' }}>
                <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
              </ContentLoader>
            ) : (
              <div style={{ display: 'flex', gap: '12px' }}>
                <MobileMenu
                  mobileTabsSort={mobileSortTabs}
                  handleTabClickSort={handleTabClickSort}
                  activeSortName={activeSortName}
                  setActiveSort={setActiveSort}
                  dataFiltersMobile={newDataFiltersMobile}
                  initialFilters={{
                    genders: params.genders ?? [],
                    issues: params.issues ?? [],
                    nationalities: params.nationalities ?? [],
                    categories: params.categories ?? [],
                    contracts: params.contracts ?? [],
                    limit_from: params.limit_from,
                    limit_to: params.limit_to,
                    date_add: params.date_add,
                  }}
                  onApplyFilters={handleApplyEmployedsFilters}
                  onResetFilters={handleResetEmployedsFilters}
                  mobileTabs={mobileTabs}
                  activeTabName={activeTabName}
                  toggleSearchOpen={toggleSearchOpen}
                  handleTabClick={handleTabClick}
                />
              </div>
            )}
          </div>
          {showFullPageSkeleton ? (
            <LoadingSkeleton />
          ) : (
            <EmployedsListMobile
              data={data?.data || []}
              intersectionComponent={
                hasNextPage && isMobile ? (
                  <div style={{ height: '10px' }} ref={intersectionRef} />
                ) : null
              }
              key={data?.meta?.total}
              activeTab={active}
              setIsCreatedModalOpen={setIsCreatedModalOpen}
            />
          )}
          {canManage ? (
            <Affix
              hiddenFrom='sm'
              position={{ bottom: 34, right: 0, left: 0 }}
              w='fit-content'
              m='0 auto'
              style={{ display: 'flex', justifyContent: 'center' }}>
              <Group gap='12px' wrap='nowrap'>
                <Box
                  p='12px'
                  bg='#002CFB'
                  h='48px'
                  w='171px'
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    color: 'white',
                    borderRadius: '4px',
                  }}
                  onClick={openModal}>
                  Пригласить <IconPlus />
                </Box>
                <ScrollButton isMobile={isMobile} />
              </Group>
            </Affix>
          ) : (
            <Affix
              hiddenFrom='sm'
              position={{ bottom: 34, right: 34 }}
              w='fit-content'
              m='0 auto'
              style={{ display: 'flex', justifyContent: 'center' }}>
              <ScrollButton isMobile={isMobile} />
            </Affix>
          )}
        </Box>
      ) : null}

      {isMediumScreen ? (
        <Box className={styles.root} mt={-20}>
          <div className={styles.stickyHeader}>
            <div className={styles.root_title}>
              <MainTitle title='Избранные исполнители' count={data?.meta?.total || 0} />
              {canManage && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                  }}>
                  {buttonTransform ? (
                    <Button
                      onClick={isDownloading ? undefined : handleDownload}
                      className={styles.root_title_btn}
                      theme='outline'>
                      <div>
                        Выгрузить в Excel{' '}
                        <div style={{ width: '20px', height: '20px' }}>
                          {isDownloading ? (
                            <Loader size='xs' color='#002CFB' />
                          ) : (
                            <IconDownload width={20} height={20} />
                          )}
                        </div>
                      </div>
                    </Button>
                  ) : (
                    <AppTooltip label={`Выгрузить в Excel`}>
                      <button
                        onClick={isDownloading ? undefined : handleDownload}
                        className={styles.headerBtn}>
                        {isDownloading ? (
                          <Loader size='xs' color='#002CFB' />
                        ) : (
                          <img
                            src={download}
                            alt='Выгрузить в Excel'
                            style={{ width: '20px', height: '20px' }}
                          />
                        )}
                      </button>
                    </AppTooltip>
                  )}
                  <Button
                    onClick={openModal}
                    className={styles.root_title_btn}
                    theme='filed'>
                    <div>
                      Пригласить исполнителя <IconPlus />
                    </div>
                  </Button>
                </div>
              )}
            </div>
            <div className={styles.root_search}>
              <div className={styles.line_filters}>
                <div className={styles.root_search_item}>
                  <InputSearch
                    notFocus
                    style={{
                      minWidth: '230px',
                      maxWidth: '260px',
                      height: '48px',
                    }}
                    value={searchValue}
                    fetching={isFetching}
                    onKeyDown={handleKeyDown}
                    onSearch={() => {
                      setParams((prev) => ({
                        ...prev,
                        page: 1,
                        searchValue: searchValue,
                      }));
                    }}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setSearchValue(e.target.value);

                      if (e.target.value === '') {
                        setParams((prev) => ({
                          ...prev,
                          page: 1,
                          searchValue: '',
                        }));
                      }
                    }}
                  />
                  {isLoadingTabs ? (
                    <ContentLoader
                      speed={2}
                      height={'44px'}
                      width={'185px'}
                      backgroundColor={'#FFFFFF'}
                      foregroundColor={'#D8E4FB8C'}>
                      <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
                    </ContentLoader>
                  ) : (
                    <div className={styles.menu}>
                      <SelectMenuFilter
                        active={active}
                        lists={dataTabs?.items}
                        setActive={(tab: string) => {
                          setParams((prev) => ({
                            ...prev,
                            page: 1,
                            filter:
                              tab === 'ready'
                                ? 'ready'
                                : tab === 'not_ready'
                                ? 'not_ready'
                                : tab === 'blocked'
                                ? 'blocked'
                                : '',
                          }));
                          setActive(tab);
                        }}
                        localStorageKey='employedsFilter'
                      />
                    </div>
                  )}
                </div>

                <div>
                  {isLoadingTabs ? (
                    <ContentLoader
                      speed={2}
                      height={'44px'}
                      width={'185px'}
                      backgroundColor={'#FFFFFF'}
                      foregroundColor={'#D8E4FB8C'}>
                      <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
                    </ContentLoader>
                  ) : (
                    <div style={{ display: 'flex' }}>
                      <SortFilter
                        lists={dataFilters?.sort || []}
                        active={activeSort}
                        setActive={(tab: string) => {
                          setActiveSort(tab);
                          setParams((prev) => ({
                            ...prev,
                            page: 1,
                            sort:
                              tab === 'default'
                                ? undefined
                                : tab === 'active'
                                ? 'active'
                                : tab === 'inactive'
                                ? 'inactive'
                                : tab === 'last_name_asc'
                                ? 'last_name_asc'
                                : tab === 'last_name_desc'
                                ? 'last_name_desc'
                                : tab === 'created_at_desc'
                                ? 'created_at_desc'
                                : tab === 'created_at_asc'
                                ? 'created_at_asc'
                                : undefined,
                          }));
                        }}
                        localStorageKey='employedsSort'
                        isLoading={isFetching || isLoading}
                      />
                      <Filters
                        dataFilters={
                          dataFilters?.filters ?? {
                            genders: [],
                            issues: [],
                            categories: [],
                            contracts: [],
                            nationalities: [],
                          }
                        }
                        initialFilters={{
                          genders: params.genders ?? [],
                          issues: params.issues ?? [],
                          nationalities: params.nationalities ?? [],
                          categories: params.categories ?? [],
                          contracts: params.contracts ?? [],
                          limit_from: params.limit_from,
                          limit_to: params.limit_to,
                          date_add: params.date_add,
                        }}
                        onApplyFilters={handleApplyEmployedsFilters}
                        onResetFilters={handleResetEmployedsFilters}
                        isLoading={isFetching || isLoading}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            {!((!openNav && isLessThan1595px) || isLessThan1400px) && (
              <div style={{ backgroundColor: '#fff', borderRadius: '8px 8px 0 0' }}>
                <TitleRow
                  data={dataTitle}
                  title={role === 'director' ? 'employedsCustomer' : 'employeds'}
                />
              </div>
            )}
          </div>
          {isLoading || isShowLoading ? (
            <LoadingSkeleton />
          ) : (
            <>
              {(!openNav && isLessThan1595px) || isLessThan1400px ? (
                <EmployedsTabletList
                  data={data?.data || []}
                  intersectionComponent={
                    hasNextPage && !isMobile ? <div ref={intersectionRef} /> : null
                  }
                  key={data?.meta?.total}
                  setIsCreatedModalOpen={setIsCreatedModalOpen}
                />
              ) : (
                <EmployedsList
                  data={data?.data || []}
                  dataTitle={dataTitle}
                  intersectionComponent={
                    hasNextPage && !isMobile ? <div ref={intersectionRef} /> : null
                  }
                  key={data?.meta?.total}
                  hideTitleRow
                  setIsCreatedModalOpen={setIsCreatedModalOpen}
                />
              )}
            </>
          )}
          <Affix position={{ bottom: 50, left: openNav ? 80 : 286 }} zIndex={1000}>
            <ScrollButton />
          </Affix>
        </Box>
      ) : null}

      {!isLoading && isFetching && params.page > 1 && data?.data?.length > 0 && (
        <div
          className={styles.loaders}
          style={{ paddingBottom: isMobile ? '150px' : '25px' }}>
          <Loader size='xs' color='#002cfb' />
        </div>
      )}

      {isCreatedModalOpen && (
        <CreateEmployedsСategory
          variant={isMobile ? 'drawer' : 'modal'}
          setIsShowFinishModal={setIsCreatedModalOpen}
          setShowCopiedSuccess={setShowCopiedSuccess}
        />
      )}
      {showCopiedSuccess && (
        <SuccessErrorInfo
          text='Создана новая категория'
          type='success'
          handleClose={handleCloseCopiedSuccess}
        />
      )}

      {showPushInvite && (
        <PushInvite
          showPushInvite={showPushInvite}
          setShowPushInvite={setShowPushInvite}
          refetch={refetch}
        />
      )}
      {textError && (
        <SuccessErrorInfo
          type='error'
          text={textError}
          handleClose={() => setTextError(null)}
        />
      )}
    </Layout>
  );
};

const transformFilters = (data: {
  genders: KeysFiltersType[];
  issues: KeysFiltersType[];
  nationalities: KeysFiltersType[];
  contracts: KeysFiltersType[];
  categories: KeysFiltersType[];
}) => {
  return {
    genders: data?.genders?.map((item, i) => ({
      id: i + 1,
      keyword: item.keyword,
      label: item.title,
    })),
    issues: data?.issues?.map((item, i) => ({
      id: i + 1,
      keyword: item.keyword,
      label: item.title,
    })),
    nationalities: data?.nationalities?.map((item, i) => ({
      id: i + 1,
      keyword: item.keyword,
      label: item.title,
    })),
    contracts: data?.contracts?.map((item, i) => ({
      id: i + 1,
      keyword: item.keyword,
      label: item.title,
    })),
    categories: data?.categories?.map((item, i) => ({
      id: i + 1,
      keyword: item.keyword,
      label: item.title,
    })),
  };
};
